(function() {
  'use strict';

  angular
    .module('wmGitHubUib', ['ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'percentCircle-directive'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 100,
        deleteSpeed: 80,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'navbarCtrl',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($scope, $document, $window, $uibModal) {
      var sideNavIsOpen = false;
      var modalDefaults = {
        backdrop: true,
        keyboard: true,
        modalFade: true
      };

      var vm = this;
      vm.navbarCollapsed = true;
      vm.sideNavToggle = sideNavToggle;
      vm.navbarCollapse = navbarCollapse;
      vm.showAboutModal = showAboutModal;
      vm.showContactModal = showContactModal;

      function navbarCollapse() {
        if ($window.innerWidth < 768) {
          vm.navbarCollapsed = !vm.navbarCollapsed;
        }
      }

      function sideNavToggle() {
        sideNavIsOpen ? closeNav() : openNav();
        if (!vm.navbarCollapsed) {
          vm.navbarCollapsed = !vm.navbarCollapsed;
        }
        sideNavIsOpen = !sideNavIsOpen;
      }

      function openNav() {
        angular
          .element($document[0].querySelector('#mySidenav'))[0]
          .style.width = "250px";
      }

      function closeNav() {
        angular
          .element($document[0].querySelector('#mySidenav'))[0]
          .style.width = "0";
      }

      function showAboutModal() {
        var aboutModal = modalDefaults;
        aboutModal.templateUrl = '/assets/templates/about.modal.html';

        aboutModal.controller = function($scope, $uibModalInstance) {
          $scope.modalOk = function(result) {
            $uibModalInstance.close(result);
            closeNav();
            sideNavIsOpen = !sideNavIsOpen;
          };
        };
        return $uibModal.open(aboutModal).result;
      }

      function showContactModal() {
        var contactModal = modalDefaults;
        contactModal.templateUrl = '/assets/templates/contact.modal.html';

        contactModal.controller = function($scope, $uibModalInstance) {
          $scope.modalSend = function(result) {
            $uibModalInstance.close(result);
            closeNav();
            sideNavIsOpen = !sideNavIsOpen;
          };
          $scope.modalCancel = function(result) {
            $uibModalInstance.dismiss('cancel');
            closeNav();
            sideNavIsOpen = !sideNavIsOpen;
          };
        };
        return $uibModal.open(contactModal).result;
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {

  }
})();

(function(){
  'use strict';

  angular
    .module('wmGitHubUib')
    .controller('ConstructionController', ConstructionController);

  function ConstructionController() {

  }

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .controller('CvController', CvController);

  /** @ngInject */
  function CvController($window, $http, $log) {
    var vm = this;
    vm.justifyTabs = true;
    vm.skills = null;
    vm.colors = {
      'center': 'white',
      'highlight': 'orange',
      'remaining': 'lightGray'
    };

    activate();

    function activate() {
      if ($window.innerWidth < 768) {
        vm.justifyTabs = false;
      }
      $http.get('/assets/skills.json')
        .then(function(response) {
          vm.skills = response.data.data;
          angular.forEach(vm.skills, function(skill) {
            skill.rank = Math.random();
          });
        })
        .catch(function(error) {
          $log.error(error.data, error.status, error.statusText);
        });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('construction', {
        url: '/in-progress',
        templateUrl: 'app/construction/construction.html'
      })
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('cv', {
        url: '/cv/',
        templateUrl: 'app/cv/cv.html',
        controller: 'CvController',
        controllerAs: 'cvCtrl'
      })
      .state('history', {
        url: '/history/',
        templateUrl: 'app/history/history.html'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* ----------global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('wmGitHubUib');
    // .constant('malarkey', malarkey)
    // .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('wmGitHubUib')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }

})();

angular.module("wmGitHubUib").run(["$templateCache", function($templateCache) {$templateCache.put("app/construction/construction.html","<div class=container><div class=\"jumbotron notrespassing\"><h1>This page is under Construction</h1></div></div>");
$templateCache.put("app/history/history.html","<div class=\"container center-text\"><h1>Lemme tell you a story</h1><p>But later, now I\'m busy</p></div>");
$templateCache.put("app/cv/cv.html","<div class=container-fluid style=\"margin-bottom: 60px; padding-top: 60px\"><div class=row style=margin-top:60px><div class=text-center><img class=img-wdyd-banner src=assets/images/wdyd.png></div><div class=container><uib-tabset active=0 justified=cvCtrl.justifyTabs><uib-tab index=0 heading=\"Skill Set\"><div class=container-fluid style=\"background-color: white\"><uib-accordion close-others=true ng-cloak><div class=\"col-sm-6 col-md-4\" style=\"padding: 10px\" ng-repeat=\"skill in cvCtrl.skills | orderBy:\'rank\'\"><div uib-accordion-group class=panel-default><uib-accordion-heading><div class=caption><percent-circle percent=skill.level colors=cvCtrl.colors></percent-circle><h3>{{ skill.name }}</h3></div></uib-accordion-heading><p class=text-justify>{{ skill.description }}</p></div></div></uib-accordion></div></uib-tab><uib-tab index=1 heading=Studies><div class=container-fluid style=\"background-color: white\"></div></uib-tab><uib-tab index=2 heading=Experience><div class=container-fluid style=\"background-color: white\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"container text-center\" style=\"padding-top: 60px\"><div class=cover><img src=assets/images/profile.png class=\"img-profile img-circle\"></div></div><div class=container><div class=\"jumbotron text-center\"><h1 style=\"box-shadow: inset 0px -1px 0px 0px black\">Welcome</h1><br><h2>Let me introduce myself</h2><br><p class=lead>My name is <span style=\"font-size: 24px; font-weight: bold\">JuanMa</span> , but friends, and non-spanish people who find hard to pronounce the spanish phoneme <span style=\"font-style: italic; font-weight: bold\">\'/x/\'</span>, usually call me <span style=\"font-size: 24px; font-weight: bold\">Wan</span>.</p><p class=text-right><button type=button class=\"btn btn-sm btn-default\" ui-sref=history>More about me</button></p></div><div class=row style=margin-top:60px><div class=container><div class=thumbnail style=\"background-color: transparent; color: orange; border: none\"><h1>I want you to get to know me a lil\' more.</h1><br><p class=lead>This website\'s main objective it\'s to show some of my personal skills and give an overall vision of my personality and my professional career path.</p></div><div class=text-center><a ui-sref=cv ui-href=#/cv><img class=img-wdyd src=assets/images/wdyd.png></a></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-fixed-top navbar-inverse\"><div class=container-fluid ng-cloak><div class=navbar-header><button type=button class=navbar-toggle style=\"border: none\" ng-click=navbarCtrl.navbarCollapse()><span class=sr-only>Toggle navigation</span> <span class=\"glyphicon glyphicon-menu-hamburger\" style=color:orange aria-hidden=true></span></button> <a class=\"navbar-brand clickable\" ng-click=navbarCtrl.sideNavToggle()><img src=assets/images/navbarBrand.png style=\"margin-top: -5px\" alt=WanMan></a></div><div class=\"navbar-collapse collapse\" uib-collapse=navbarCtrl.navbarCollapsed><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=active><a ui-sref=home ng-href=# ng-click=navbarCtrl.navbarCollapse()><small><span uib-tooltip=Home tooltip-popup-delay=1000 tooltip-placement=right class=\"glyphicon glyphicon-home\" aria-hidden=true></span> </small><span>Home</span></a></li><li ui-sref-active=active><a ui-sref=cv ng-href=# ng-click=navbarCtrl.navbarCollapse()><small><span uib-tooltip=CV tooltip-popup-delay=1000 tooltip-placement=right class=\"glyphicon glyphicon-education\" aria-hidden=true></span> </small><span>CV</span></a></li><li ui-sref-active=active><a ui-sref=history ng-href=# ng-click=navbarCtrl.navbarCollapse()><small><span uib-tooltip=History tooltip-popup-delay=1000 tooltip-placement=right class=\"glyphicon glyphicon-book\" aria-hidden=true></span> </small><span>History</span></a></li></ul></div></div></nav><div id=mySidenav class=\"sidenav navbar-inverse\"><ul class=\"nav navbar-nav\"><li><a class=btn ng-click=navbarCtrl.showAboutModal()><small><span class=\"glyphicon glyphicon-info-sign\" aria-hidden=true></span> </small>About</a></li><li><a class=btn ng-click=navbarCtrl.showContactModal()><small><span class=\"glyphicon glyphicon-envelope\" aria-hidden=true></span> </small>Contact</a></li></ul></div>");}]);